import { na1 } from 'hubspot-url-utils/hublets';
import { getFullUrlPure } from 'hubspot-url-utils/pure';
const getV3EmbedCode = ({
  portalId,
  formId,
  env = 'prod',
  region = na1,
  sfdcCampaignId
}) => {
  const regionToInsert = region || na1;
  const newSrc = getFullUrlPure('js', regionToInsert, env, {
    domainOverride: 'hsforms',
    tldOverride: 'net'
  });
  const scriptSrc = `${newSrc}/forms/embed/frame.js`;
  const dataEnv = `${env ? ` data-env="${env}"` : ''}`;
  const dataRegion = `${regionToInsert ? ` data-region="${regionToInsert}"` : ''}`;
  const dataSelectedCampaignId = `${sfdcCampaignId ? ` data-sfdc-campaign-id="${sfdcCampaignId}"` : ''}`;
  return `<script src="${scriptSrc}" defer></script>\n<div class="hs-form-frame" data-form-id="${formId}" data-portal-id="${portalId}"${dataEnv}${dataRegion}${dataSelectedCampaignId}></div>`;
};
export default getV3EmbedCode;